import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import { withTranslation } from 'react-i18next';

class AddLeadForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            email: '',
            phone: '',
            message: '',
            extraFields: [{name: '', value: ''}],
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleExtraFieldNameChange = this.handleExtraFieldNameChange.bind(this);
        this.handleExtraFieldValueChange = this.handleExtraFieldValueChange.bind(this);
        this.handleAddExtraField = this.handleAddExtraField.bind(this);
    }

    handleAddExtraField(event) {
        const extraFields = this.state.extraFields.concat({name: '', value: ''});
        this.setState({
            extraFields: extraFields
        })
    }

    handleExtraFieldValueChange(event) {
        const extraFieldNumber = event.target.name;
        let extraFields = this.state.extraFields;
        extraFields[extraFieldNumber].value = event.target.value;
        this.setState({
            ...this.state,
            extraFields: extraFields
        })
    }

    handleExtraFieldNameChange(event) {
        const extraFieldNumber = event.target.name;
        let extraFields = this.state.extraFields;
        extraFields[extraFieldNumber].name = event.target.value;
        this.setState({
            ...this.state,
            extraFields: extraFields
        })
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;

        this.setState({
            [name]: target.value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.onLeadAdded(this.state)
    }

    renderSaveButton() {
        const { t } = this.props;
        return <input onClick={this.handleSubmit} type="submit" value={t('add_button')} className="btn -alt"/>
    }

    renderExtraFields() {
        return Object.entries(this.state.extraFields).map((indexAndValue) => {
            const index = indexAndValue[0];
            const extraField = indexAndValue[1];

            return (
                <div key={index} className="extra-field-row">
                    <div key='field-name' className="extra-field-col">
                        <input name={index} onChange={this.handleExtraFieldNameChange} value={extraField.name}
                               type="text"/>
                    </div>
                    <div key='field-value' className="extra-field-col">
                        <input name={index} onChange={this.handleExtraFieldValueChange} value={extraField.value}
                               type="text"/>
                    </div>
                </div>
            )
        });
    }

    render() {
        const { t } = this.props;
        return (
            <form>
                <ModalBody className="crm-modal-body">
                    <div className="form-big-input">
                        <label>{t('add_lead_form.lead_name')}</label>
                        <input value={this.state.name} onChange={this.handleChange} name="name" type="text"/>
                    </div>
                    <div className="modal-section">
                        <div className="form-header">
                            <h3 className="form-title">{t('add_lead_form.contact_info')}</h3>
                        </div>
                        <div className="form-grid">
                            <div className="form-col">
                                <label>{t('add_lead_form.phone')}</label>
                                <input value={this.state.phone} onChange={this.handleChange} name="phone" type="text"/>
                            </div>
                            <div className="form-col">
                                <label>{t('add_lead_form.email')}</label>
                                <input value={this.state.email} onChange={this.handleChange} name="email" type="text"/>
                            </div>
                        </div>
                        <div className="form-grid">
                            <label>{t('lead_detail.message')}</label>
                            <textarea className="textarea" value={this.state.message} onChange={this.handleChange}
                                      name="message"/>
                        </div>
                        <div className="form-header">
                            <h3 className="form-title">{t('add_lead_form.other_fields')}</h3>
                        </div>
                        <div className="extra-field-row">
                            <div className="extra-field-col">
                                <label>{t('add_lead_form.field_input')}</label>
                            </div>
                            <div className="extra-field-col">
                                <label>{t('add_lead_form.field_data')}</label>
                            </div>
                        </div>
                        {this.renderExtraFields()}
                        <div className="extra-field-row add-field">
                            <button type='button' onClick={this.handleAddExtraField} className="plus-button">+</button>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.renderSaveButton()}
                </ModalFooter>
            </form>
        )
    }
}

export default withTranslation()(AddLeadForm);
